import request, { requestV2 } from 'store/common/utils';
export const getRegionsApi = () => requestV2({
    url: '/regions',
    method: 'GET',
});
export const getEmirateApi = (data) => request({
    url: `/emirates/${data.id}`,
    method: 'GET',
});
export const createEmirateApi = (data) => request({
    url: `/emirates`,
    method: 'POST',
    data,
});
export const editEmirateApi = (data) => request({
    url: `/emirates/${data.id}`,
    method: 'PUT',
    data,
});
export const deleteEmirateApi = (data) => request({
    url: `/emirates/${data.id}`,
    method: 'DELETE',
});
